<template>
	<div class="sd-wrap-content">
		<div v-if="fullImage" class="sd-wrap-full-image" @click="hideFullImage">
			<div class="sd-full-image">
				<img :src="require(`@/assets/${fullImage.src}`)" :alt="fullImage.alt" />
				<i class="fas fa-times" @click="hideFullImage"></i>
			</div>
			<div class="sd-image-alt">
				<p>{{ fullImage.alt }}</p>
			</div>
		</div>
		<a id="Smartphone" name="Smartphone"></a>
		<h2>{{ $t('sdAppTitle') }}</h2>
		<SmartphoneContent @showFullImage="showFullImage" />
		<a id="Connection" name="Connection"></a>
		<h2>{{ $t('sdConTitle') }}</h2>
		<ConnectionContent @showFullImage="showFullImage" />
		<a id="Database" name="Database"></a>
		<h2>{{ $t('sdDataTitle') }}</h2>
		<DatabaseContent @showFullImage="showFullImage" />
		<a id="Client" name="Client"></a>
		<h2>{{ $t('sdClientTitle') }}</h2>
		<ClientContent @showFullImage="showFullImage" />
		<div id="scrollUp" class="sd-scroll-up">
			<i class="fas fa-arrow-up" @click="scrollToTop"></i>
			<p class="sd-up-text" @click="scrollToTop">{{ $t('sdBackUp') }}</p>
		</div>
	</div>
</template>

<script>
import SmartphoneContent from './descriptions/SmartphoneContent';
import ConnectionContent from './descriptions/ConnectionContent';
import DatabaseContent from './descriptions/DatabaseContent';
import ClientContent from './descriptions/ClientContent';
export default {
	name: 'SystemDetails',
	components: {
		SmartphoneContent,
		ConnectionContent,
		DatabaseContent,
		ClientContent,
	},
	data() {
		return {
			fullImage: null,
		};
	},
	created() {
		document.querySelector('.ap-scroll-view').addEventListener('scroll', this.scrollListener);
	},
	beforeDestroy() {
		document.querySelector('.ap-scroll-view').removeEventListener('scroll', this.scrollListener);
	},
	methods: {
		scrollListener() {
			let element = document.getElementById('Overview');
			let rect = element.getBoundingClientRect();
			if (rect.top > 0) document.getElementById('scrollUp').style.display = 'none';
			else document.getElementById('scrollUp').style.display = 'block';
		},
		scrollToTop() {
			document.querySelector('#Overview').scrollIntoView({ behavior: 'smooth' });
			document.getElementById('scrollUp').style.display = 'none';
		},

		showFullImage(image) {
			document.querySelector('.ap-scroll-view').style.overflowY = 'hidden';
			this.fullImage = image;
		},
		hideFullImage() {
			document.querySelector('.ap-scroll-view').style.overflowY = 'auto';
			this.fullImage = null;
		},
	},
};
</script>

<style>
.sd-wrap-content {
	position: relative;
}

.sd-wrap-full-image {
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0px;
	left: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-flow: column;
	box-sizing: border-box;
	padding: 15px;
	background-color: #000000bb;
	z-index: 10;
}

.sd-full-image {
	height: calc(100vh - 60px);
	display: flex;
	align-items: center;
	justify-content: center;
}

.sd-image-alt {
	height: 40px;
}

.sd-full-image img {
	max-width: 90vw;
	max-height: 90vh;
}

.sd-full-image i {
	position: absolute;
	top: 15px;
	right: 25px;
	font-size: 40px;
	color: var(--main-color-text-light);
}

.sd-full-image i:hover {
	cursor: pointer;
	color: #ffffffaa;
}

.sd-wrap-content h2 {
	margin: 0px;
	padding: 30px 0px 0px 0px;
	font-size: 45px;
	color: var(--main-color-text-light);
	/* background-color: #ffffff80; */
}

.sd-wrap-content h3 {
	font-size: 35px;
	color: var(--main-color-text-light);
}

.sd-wrap-content p {
	font-size: 20px;
	color: var(--main-color-text-light);
}

.sd-wrap-content ul {
	color: var(--main-color-text-light);
}

.sd-wrap-content li {
	color: var(--main-color-text-light);
}

.sd-wrap-content a {
	color: var(--secondary-color-highlight);
}

.sd-wrap-content a:visited {
	color: var(--secondary-color-highlight);
}

.sd-scroll-up {
	display: none;
	position: fixed;
	bottom: -10px;
	right: 20px;
	text-align: end;
	padding: 10px;
}
.sd-scroll-up i {
	color: var(--main-color-text-light);
	font-size: 30px;
}
.sd-scroll-up i:hover {
	cursor: pointer;
	color: var(--main-color-highlight);
}

.sd-up-text {
	font-size: 15px !important;
	width: 30px;
	cursor: pointer;
}

.sd-wrap-box {
	height: fit-content;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff40;
	padding: 0px 5vw;
	box-sizing: border-box;
	text-align: justify;
}

.sd-title-right {
	/* float: right; */
	margin-right: 50px;
}

.sd-title-left {
	/* float: left; */
	margin-left: 50px;
}

.sd-content {
	display: inline-block;
	width: calc(100% - 330px);
	vertical-align: top;
	font-size: 20px;
	padding: 0px 10px;
}

.sd-content-half {
	display: inline-block;
	width: 40vw;
	vertical-align: top;
	font-size: 20px;
	padding: 0px 10px;
}

.sd-content-full {
	display: inline-block;
	width: 100%;
	vertical-align: top;
	font-size: 20px;
}

.sd-img {
	display: inline-block;
	/* width: 330px; */
	padding: 0px;
	vertical-align: top;
}

.sd-img-half {
	display: inline-block;
	width: 50vw;
	/* padding: 15px; */
	vertical-align: top;
	box-sizing: border-box;
}

.sd-img-half img {
	max-width: calc(50vw - 70px);
}

.sd-img img {
	max-width: 300px;
	max-height: 800px;
}

.sd-img img,
.sd-img-half img {
	-webkit-filter: drop-shadow(5px 10px 10px #000000);
	filter: drop-shadow(5px 10px 10px #000000);
}

.sd-divider {
	width: 90%;
	height: 20px;
	margin: auto;
	border-bottom: 2px solid var(--main-color-border-light);
}

.sd-img-left {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	-webkit-animation-name: fadeInLeft;
	animation-name: fadeInLeft;
}

.sd-img-right {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight;
}

.sd-horizontal {
	display: block;
}

.sd-vertical {
	display: none;
}

@keyframes fadeInLeft {
	0% {
		opacity: 0;
		transform: translateX(-50px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@-webkit-keyframes fadeInLeft {
	0% {
		opacity: 0;
		transform: translateX(-50px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		transform: translateX(50px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		transform: translateX(50px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@media screen and (max-width: 800px) {
	.sd-wrap-box {
		height: fit-content;
		display: block;
		background-color: #ffffff40;
		padding: 0px 5vw;
		box-sizing: border-box;
		text-align: justify;
	}

	.sd-content {
		display: block;
		width: 100%;
		font-size: 20px;
		padding: 10px 0px;
		box-sizing: border-box;
	}

	.sd-content-half {
		display: block;
		width: calc(100% - 20px);
		font-size: 20px;
	}

	.sd-content-full {
		display: block;
		width: 100%;
		font-size: 20px;
		padding: 10px;
		box-sizing: border-box;
	}

	.sd-img {
		display: block;
		/* width: 330px; */
		width: 90vw;
		padding: 0px;
		box-sizing: border-box;
	}

	.sd-img-half {
		display: block;
		width: 90vw;
		/* padding: 15px; */
		box-sizing: border-box;
	}

	.sd-img-half img {
		max-width: calc(90vw - 70px);
	}

	.sd-img img {
		max-width: 300px;
		max-height: 800px;
	}

	.sd-divider {
		width: 90%;
		height: 20px;
		margin: auto;
		border-bottom: 2px solid var(--main-color-border-light);
	}

	.sd-horizontal {
		display: none;
	}

	.sd-vertical {
		display: block;
	}
}

@media (pointer: none), (pointer: coarse) {
	.sd-wrap-content h2 {
		margin: 0px;
		padding: 30px 0px 0px 0px;
		font-size: 35px;
		color: var(--main-color-text-light);
		/* background-color: #ffffff80; */
	}

	.sd-title-left,
	.sd-title-right {
		/* float: right; */
		margin: auto;
	}

	.sd-wrap-content h3 {
		font-size: 25px;
		color: var(--main-color-text-light);
		margin: 15px auto !important;
	}

	.sd-wrap-content p,
	.sd-wrap-content ul,
	.sd-wrap-content li {
		font-size: 17px;
		color: var(--main-color-text-light);
	}

	.sd-content {
		padding: 10px 0px;
		box-sizing: border-box;
	}

	.sd-content-half {
		padding-top: 10px;
		/* box-sizing: border-box; */
	}

	.sd-content-full {
		padding: 10px;
		box-sizing: border-box;
	}

	.sd-img {
		display: block;
		/* width: 330px; */
		width: 90vw;
		padding: 0px;
		box-sizing: border-box;
	}

	.sd-img-half {
		display: block;
		width: 90vw;
		/* padding: 15px; */
		box-sizing: border-box;
	}

	.sd-img-half img {
		max-width: calc(90vw - 70px);
	}

	.sd-img img {
		max-width: 70vw;
		max-height: 100vh;
	}

	.sd-horizontal {
		display: none;
	}

	.sd-vertical {
		display: block;
	}
}
</style>
